import {RJSFSchema} from "@rjsf/utils";
import {ConfigType} from "../ps-types";
import {Container} from "semantic-ui-react";
import {Configurator} from "./Configurator";


export function WhatIfScenariosConfig() {
  return <Container>
    <h1>What If Scenarios Config</h1>
    <Configurator configType={ConfigType.WhatIfScenario}
                  schema={WhatIfScenarioJSONSchema}
    />
  </Container>
}


export const WhatIfScenarioJSONSchema: RJSFSchema = {
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "definitions": {
    "DSNone":{
      type: "null",
      title:"None",
    },
    "DSQuery":{
      type: "object",
      title:"Query",
      "properties": {
        "type": {
          "type": "string",
          "enum": ["query"],
          "readOnly": true,
          default: "query",
        },
        "lineItemName": {
          title: "Line Item Name",
          "type": "string"
        },
      },
      "required": ["type", "lineItemName"]
    },
    "DSSalesforce": {
      type: "object",
      title:"Salesforce",
      "properties": { 
        "type": {
          title: "Type",
          "type": "string",
          "enum": ["salesforce"],
          "readOnly": true,
          default: "salesforce",
        },
        // @TODO: add Salesforce config fields
        "TBD": {
          title: "TBD",
          "type": "string"
        },
      },
      "required": ["type","TBD"]
    },
    "MappingConfigEntry": {
      "type": "object",
      title: "",
      "properties": {
        "valueKey": {
          title: "Value Key",
          type: "string"
        },
        "label": {
          title: "Label",
          type: "string"
        },
        "locator": {
          type: "object",
          title: "Excel Locator",
          "properties": {
            "label": {
              title: "Excel Label",
              "type": "string"
            },
            "type": {
              title: "Type",
              "type": "string",
              "enum": ["table", "cell", "parameter"]
            },
            "direction": {
              title: "Direction (left, right, down)",
              "type": "string"
            },
            "skipNValues": {
              title: "Skip N Values",
              "type": "number"
            },
            "extra": {
              title: "Extra",
              "type": "object",
              "properties": {
                "valueType": {
                  title: "Value Type",
                  "enum": ["percentx100"] // @TODO: add more value types, also support them in the WhatIfScenarioService
                }
              }
            },
            "workSheet": {
              title: "WorkSheet",
              "type": "string"
            },
          },
          "required": ["type", "label", "workSheet"],
          "if": {
            "properties": {
              "type": {
                "const": "table"
              }
            }
          },
          "then": {
            "properties": {
              "skipColumns": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              },
              "tableLayout": {
                "type": "string",
                "enum": ["label-top-left-inside", "label-top-left-outside"]
              },
              "headers": {
                "type": "object",
                "properties": {
                  "horizontal": {
                    "type": "object",
                    "properties": {
                      "includeLabel": {
                        "type": "boolean"
                      }
                    }
                  },
                  "vertical": {
                    "type": "object",
                    "properties": {
                      "includeLabel": {
                        "type": "boolean"
                      }
                    }
                  }
                }
              }
            }
          }
        },
        "dataSource": {
          title: "Data Source",
          "type": ["object", "null"],
          "oneOf": [
            {
              "$ref": "#/definitions/DSNone"
            },
            {
              "$ref": "#/definitions/DSQuery"
            },
            {
              "$ref": "#/definitions/DSSalesforce"
            }
        ]
        }
      },
      required: ["valueKey", "locator", "label"]
    },
  },

  "properties": {
    "configName": {
      "type": "string"
    },
    "configKey": {
      "type": "string"
    },
    "mappingConfig": {
      "type": "object",
      title: "Mapping Config",
      "additionalProperties": {
        title: "Config",
        "$ref": "#/definitions/MappingConfigEntry"
      }
    }
  },
  "required": ["configName", "configKey", "locatorMap"]
}